<template>
  <div class="row bottom-xs base-table__header">
    <p
      class="col-xs-3 table-headline"
      @click="onSortChange('name')"
      :class="{'table-headline--active': sort.key === 'name'}"
    >
      Navn
      <font-awesome-icon
        :icon="sortDirection"
        v-show="sort.key === 'name'"
      />
    </p>
    <p
      class="col-xs-3 table-headline"
      @click="onSortChange('publishedDate')"
      :class="{'table-headline--active': sort.key === 'publishedDate'}"
    >
      Publiceringsdato
      <font-awesome-icon
        :icon="sortDirection"
        v-show="sort.key === 'publishedDate'"
      />
    </p>
    <p
      class="col-xs-3 table-headline"
      @click="onSortChange('nextPublishedDate')"
      :class="{'table-headline--active': sort.key === 'nextPublishedDate'}"
    >
      Næste publicering
      <font-awesome-icon
        :icon="sortDirection"
        v-show="sort.key === 'nextPublishedDate'"
      />
    </p>
    <p class="col-xs-3">
      Status
    </p>
  </div>
</template>

<script>
export default {
    name: 'TableRowHeader',
    props: {
        sort: { type: Object, required: true },
    },
    computed: {
        sortDirection() {
            return this.sort.direction === 'asc' ? 'angle-up' : 'angle-down';
        },
    },
    methods: {
        onSortChange(activeName) {
            if (this.sort.key === activeName) {
                this.toggleSort();
                return;
            }

            this.sort.key = activeName;
            this.setDefaultSort();
        },
        toggleSort() {
            this.sort.direction = this.sort.direction === 'asc' ? 'desc' : 'asc';
        },
        setDefaultSort() {
            this.sort.direction = 'asc';
        },
    },
};
</script>

<style lang="scss" scoped>
.base-table__header {
    margin-top: 50px;
}

.table-headline {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    &--active {
        font-weight: bold;
    }

    svg {
        margin-left: 5px;
    }
}
</style>
